import type { Job, Payment, Expense } from '@/types';

export interface FinanceSummary {
  ciro: number;
  collected: number;
  openReceivable: number;
  expense: number;
  netCash: number;
}

export function jobPaid(payments: Payment[], jobId: string): number {
  return payments.filter((p) => p.jobId === jobId).reduce((sum, p) => sum + p.amount, 0);
}

export function jobRemaining(job: Job, payments: Payment[]): number {
  return Math.max(0, job.jobValue - jobPaid(payments, job.id));
}

export function computeFinance(
  jobs: Job[],
  payments: Payment[],
  expenses: Expense[],
): FinanceSummary {
  const ciro = jobs.reduce((sum, j) => sum + j.jobValue, 0);
  const collected = payments.reduce((sum, p) => sum + p.amount, 0);
  const openReceivable = jobs.reduce((sum, j) => sum + jobRemaining(j, payments), 0);
  const expense = expenses.reduce((sum, e) => sum + e.amount, 0);
  return {
    ciro,
    collected,
    openReceivable,
    expense,
    netCash: collected - expense,
  };
}